import React from "react";
import { motion } from "framer-motion";

export const SectionHeading = ({ label, title, desc, light, center }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""} mb-12`}>
    {label && (
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-xs sm:text-sm uppercase tracking-[0.25em] font-bold text-brandred mb-3"
      >
        {label}
      </motion.p>
    )}
    <motion.h2
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className={`font-head text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight ${
        light ? "text-white" : "text-navy"
      }`}
    >
      {title}
    </motion.h2>
    {desc && (
      <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-200" : "text-slate-600"}`}>
        {desc}
      </p>
    )}
  </div>
);
